import axios from "axios";

export default {
	namespaced: true,
	state: () => ({
		allAge: [],
	}),
	mutations: {
		setAllAge(state, payload) {
			state.allAge = payload;
		},
	},
	actions: {
		getAllAge(context) {
			return axios
				.get("https://main-tw.mini.com.tw/shop/allage")
				.then((response) => {
					context.commit("setAllAge", response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
